<template>
	<div _bg="[#ffffff]" style="height: calc(100vh - 97px)">
		<div class="ability-detail-header" @click="routeBack">
			<i class="el-icon-arrow-left" style="margin-right: 5px;font-weight: 1000;"></i>返回
		</div>
		<div _p="l-25px t-21px b-15px" _text="[#B0B0B0]">以下设置配置将会在创建题库、创建题目时填写信息使用到</div>
		<div _flex="~" _p="x-20px">
			<publisher class="w-basis-1/3" v-if="$permissions([`SP5111_${yy_ms}`])"/>
			<knowPoint class="w-basis-1/3" v-if="$permissions([`SP5112_${yy_ms}`])"/>
			<powerPoint class="w-basis-1/3" v-if="$permissions([`SP5113_${yy_ms}`])"/>
		</div>
	</div>
</template>
<script>
import knowPoint from './knowPoint.vue'
import powerPoint from './powerPoint.vue'
import publisher from './publisher.vue'
export default {
	components: {
		knowPoint,
		powerPoint,
		publisher
	},
	data() {
		return {
      sbid: ''
    }
	},
	methods: {
		routeBack() {
			this.$router.go(-1)
			// this.$router.push(`/workbench/abilityList`)
		}
	},
	async mounted() {
    const { sbid } =this.$route.params
    this.sbid = sbid
  },
  computed: {
		yy_ms() {
			return this.sbid == 1 ? 'yy' : this.sbid == 2 ? 'ms' : ''
		}
	},
}
</script>
<style lang="scss" scoped>
.ability-detail-header {
	display: flex;
	align-items: center;
	font-size: 16px;
	padding: 15px 15px 15px 15px;
	cursor: pointer;
}
.ability-detail-header:hover {
	color: #ff5e2a;
}
</style>
